module.exports = __webpack_public_path__ + "img/advantage1.3ab2ef39.png";